import { updateLocal } from "web3modal";

export const ApiPaths = {
  refreshToken: `/refresh-token`,
  login: `/login`,
  logout: `/logout`,
  loginWithDap: `/login-with-dap`,
  register: `/register`,
  sendRegistrationOTP: "/send-registration-otp",
  registerWithDap: `/register-with-dap`,
  registerfield: "/registerfields",
  resendVerificationEmail: "/resend-verification-email",
  verifyEmail: "/verify-email",
  checkSponsor: `/check_username`,
  checkUserInGaming: `/checkUserInGamingDB`,
  getProfile: `/get_profile`,
  getWallets: `/get_wallets`,
  previewOpenedLevels: "/preview-opened-levels",
  changePassword: `/update-password`,
  updateProfile: `/update-profile`,
  updateProfileAfterDap: `/update-profile-after-dap-register`,
  paymentRequest: "/payment-request",
  getPaymentMethod: "/get-payment-method",
  getPaymentTransaction: `/get-payment-transaction`,
  getPaymentAddress: "/get-payment-address",
  topUp: `/topup`,
  transferFundsInGaming: `/transferFunds`,
  getTeams: `/get_team_section`,
  withdraw: "/withdraw",
  tokenWithdraw: "/token_withdraw",
  getPackages: "/get-all-package",
  getLevels: "/get_level_team",
  getOrders: "/get_orders",
  placeOrderwithdap: "/place-order-with-dap",
  placeAddFundwithdap: "/place-add-fund-dap",
  confirmAddFund: "/confirm-add-fund-dap",
  confirmOrder: "/confirm-order-with-dap",
  getRanks: "/get-ranks",
  getVotingShare: "/get-voting-share",
  getALlTeam: "/get_all_team",
  generationTree: "/get_genealogy_tree",
  claimReward: "/claim_reward",
  getCommunity: "/get-community-bonus",
  getBankDetails: "/submit-bank-kyc",
  getPanCardDetails: "/submit-pan-kyc",
  getAddressDetails: "/submit-address-kyc",
  bonanzaData: "/get-bonanza",
  getCompanyDetails: "/get-company-info",
  getFloxyPayMethod: "/floxypay-payment-request",
  sendOTP: "/send-otp",
  forgotPassword: "/forgot-password",
  getManualRequest: "/manual-payment-status",
  createTicket: "/create-ticket",
  getTickets: "/get-ticket",
  getTicketsType: "/get-ticket-types",
  getBankKycDetails: "/check-kyc",
  sendOTP: "/send-otp",
  forgotPassword: "/forgot-password",
  getFirstId: "/get_first_profile",
  announcement: "/get-all-news",
  getCappingBar: "/get_capping_bar",
  getTeamBusiness: "/get_team_business",
  getProfileUsername: "/get_profile_by_username",
  addComment: "/add-comment",
  getCommunityTeamIncome: "/get_income_transaction_community_team",
  getBusinessByDate: "/getBusinessByDateRange",
  getUplineBonus: "/get_upline_bonus",
  claimRoiIncome: "/claim-roi-income",
  // getGamingActivation:"/get_gamingwallet_for_Activation",
  getGamingActivation: "/get_fast_team_grow",
  setWalletAddress: "/add-web3-details",
  getWalletAddress: "/get-web3-details",
  principalWithdraw: "/principal_withdrawal",
  p2pTransfer: "/p2p-transfer",
  swapTokens: "/convert_coin",
  convertMainToFund: "/main-to-fund-transfer",
  fundTransfer: "/fund_transfer",
  principalPreview: "/principal_withdrawal/preview",
  getAdvanceInfo: "/get-advance-info",
  livePrices: "/live-prices",
  getWithdrawalRecord: "/both-transactions",
  getBothOrders: "/both-orders",
  get_all_source: "/get_all_source",
  getAllSlots: "/get_all_slots",
  tokenWithdrawPreview: "/token_withdraw_preview",
  updateSponsor: "/update-sponsor",
  getPromoMilestone: "/get_promo_milestone",
  getPositionTeam: "/get_team_position",
  matrixTree: "/get_matrix_tree",
  updateBitunix: "/update_bitunix",
  getLevelRanks: "/get-level-ranks",
  fundConvert: "/convert_token_to_fund",
  capping_topup: "/capping_topup",
  getCappingOrders: "/get_capping_orders",
};
